import type { ReactNode } from "react";
import { BrandIcon, Wordmark } from "./Brand";

export function AuthLayout({
  children,
  title,
  subtitle,
}: {
  children: ReactNode;
  title?: string;
  subtitle?: string;
}) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-start px-6 pt-10 pb-12 max-w-md mx-auto">
      <div className="flex flex-col items-center gap-3 mb-6">
        <BrandIcon size={56} />
        <Wordmark size="md" />
      </div>
      {title && (
        <h1 className="text-2xl font-bold text-navy text-center mt-4">{title}</h1>
      )}
      {subtitle && <p className="mt-1 text-center text-ink-dark">{subtitle}</p>}
      <div className="w-full mt-6">{children}</div>
    </div>
  );
}
